import _ from 'lodash'

/**
 * Remove null and undefined properties from the given object
 *
 * Optional settings:
 * @param {boolean} [options.nonEmpty=false] remove any empty values (e.g. [], {}, '')
 */
function cleanObject(obj, options = {}) {
	return _.transform(obj, function(result, value, key) {
		let includeProperty = false
		if (!_.isNil(value)) {
			if (options.nonEmpty) {
				includeProperty = !(_.isObjectLike(value) || _.isString(value)) || !_.isEmpty(value)
			} else {
				includeProperty = true
			}
		}

		if (includeProperty) {
			result[key] = value
		}
	})
}

export default cleanObject

cleanObject.__filename__ = 'components/clean-object.js'
